<script>
import ContentInfinityScrollView from '@/components/common/content/ContentInfinityScrollView'
import {ApiPaginatedAccumulatedData} from '@/assets/js/api/_helpers'
import api from '@/assets/js/api'
import MoneyCompensationsListItem
  from '@/components/requests/matching/money/compensations/list/MoneyCompensationsListItem'

export default {
  extends: ContentInfinityScrollView,

  data() {
    return {
      apiData: new ApiPaginatedAccumulatedData(api.requests.matching.money.compensations.list),
      listItem: {
        component: MoneyCompensationsListItem,
      }
    }
  },

  computed: {
    groups() {
      return this.getGroupsByDate('issued_at')
    }
  }
}
</script>